'use strict'

let self

export default self = {
  container : document.querySelector('.overlay'),
  triggers : document.querySelectorAll('.overlay-trigger'),


  init : () => {
    Array.from( self.triggers ).forEach( trigger => trigger.addEventListener("click", self.toggleOverlay) )
  },

  toggleOverlay : e => {
    let el = e.currentTarget
    let rel = el.getAttribute("rel")
    let overlay = document.querySelector(`#${rel}`)

    if (overlay.classList.contains("active")) {
      overlay.classList.remove("active")
      document.documentElement.classList.remove("overlay-active")
    } else {
      overlay.classList.add("active")
      document.documentElement.classList.add("overlay-active")
    }

  }
}
